import { v4 as uuidv4 } from 'uuid'
import { ssoClientConfigMappings } from './config'
import { ssoStorage } from './ssoStorage'
import type { SSOClientConfig } from './types'

export function generateOAuthState(clientName: string): string {
  const nonce = uuidv4()
  ssoStorage.setStateNonce(nonce, clientName)
  return `${nonce}:${clientName}`
}

export function resolveClientFromOAuthState(state: string | null): SSOClientConfig | undefined {
  if (!state || state === 'popup_auth=true') return undefined
  const separatorIndex = state.indexOf(':')
  if (separatorIndex === -1) {
    ssoStorage.clearStateNonce()
    return undefined
  }

  const nonce = state.substring(0, separatorIndex)
  const clientName = state.substring(separatorIndex + 1)
  const stored = ssoStorage.getOAuthState()

  if (!stored) return undefined
  if (stored.nonce !== nonce || stored.clientName !== clientName) {
    ssoStorage.clearStateNonce()
    return undefined
  }

  ssoStorage.clearStateNonce()
  return ssoClientConfigMappings.find((client) => client.clientName === clientName)
}
